export const checkoutUrl =
  'https://pay.hotmart.com/Q107713454K?checkoutMode=10&bid=1790104188355'

export const images = {
  mainCover:
    'https://cdn.magicpatterns.com/uploads/a8stbGFexuNfk4TXBTFWmb/Portada_-_El_escudo_de_mama.png',
  bundle:
    'https://cdn.magicpatterns.com/uploads/cDhy2oK9SM1LiotobBviVT/Portada_General.png',
}

export const videoUrl =
  'https://res.cloudinary.com/lkfj1jku/video/upload/v1790105088/VSL.mp4'

export const mainBullets = [
  'Explicación sencilla del sistema inmune infantil.',
  'Cómo identificar enemigos silenciosos en la alacena.',
  'Recetas naturales para niños.',
  'Hábitos diarios: sueño, hidratación, alimentación y rutinas.',
  'Plan práctico de 21 días.',
  'Checklists imprimibles para mamá.',
]

export const bonuses = [
  {
    number: 1,
    title: 'Recetario Escudo Infantil',
    description:
      '30 recetas naturales para apoyar las defensas de los niños desde la cocina.',
    image:
      'https://cdn.magicpatterns.com/uploads/5LHV8LU3yQD6B6NXhpN6w4/Bono_1_-_Recetario_Escudo_Infantil.png',
    icon: 'spoon',
  },
  {
    number: 2,
    title: 'Botiquín Natural de Mamá',
    description:
      'Una guía segura de ingredientes naturales, herramientas y cuidados naturales para tener en casa.',
    image:
      'https://cdn.magicpatterns.com/uploads/6tZynNJhQVAHN1yrv1iY72/Bono_2_-_El_Botiquin_Natural_de_Mama.png',
    icon: 'leaf',
  },
  {
    number: 3,
    title: 'Guía para Niños Selectivos',
    description:
      'Estrategias prácticas para introducir alimentos naturales sin peleas en la mesa.',
    image:
      'https://cdn.magicpatterns.com/uploads/ekqsUZtDpJf4ScuWbjcb7w/Bono_3_-_Guia_para_Ninos_Selectivos.png',
    icon: 'heart',
  },
] as const

export const testimonials: { id: number; image?: string; alt: string }[] = [
  {
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/mC2LrkqXNVRf3NFKCoK1zY/testimonio_1.png',
    alt: 'Mamá primeriza cuenta que aprendió mucho con la guía y se siente mejor alimentando a su hijo',
  },
  {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/nn1Nc15bQTvAQpQGgp6YGE/testimonio_2.png',
    alt: 'Mamá cuyo hijo empezó guardería comparte que el plan de 21 días la hizo sentir más organizada',
  },
  {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/34RsNsU2X5P8QhcDApATg6/testimonio_3.png',
    alt: 'Mamá cuenta que su niña selectiva va mejorando al presentar los alimentos poco a poco',
  },
  {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/dwF8JNpnzTz4ASwe84cNGw/testimonio_4.png',
    alt: 'Mamá trabajadora dice que el recetario y el botiquín la hacen sentir más organizada',
  },
]

export const offerItems = [
  'Producto principal: El Escudo de Mamá',
  'Bono 1: Recetario Escudo Infantil',
  'Bono 2: Botiquín Natural de Mamá',
  'Bono 3: Guía para Niños Selectivos',
  'Acceso inmediato',
  'Garantía de satisfacción de 7 días',
]

export const faqs = [
  {
    question: '¿Para qué edad está pensado?',
    answer:
      'Está pensado principalmente para niños de 2 a 6 años, especialmente si están en guardería, jardín o preescolar.',
  },
  {
    question: '¿Qué recibo al comprar?',
    answer:
      'Recibes la guía principal El Escudo de Mamá y 3 bonos de regalo: Recetario Escudo Infantil, Botiquín Natural de Mamá y Guía para Niños Selectivos.',
  },
  {
    question: '¿Cómo recibo el producto?',
    answer: 'El acceso es digital e inmediato después de la compra.',
  },
  {
    question: '¿Tiene garantía?',
    answer:
      'Sí. Tienes una garantía de satisfacción de 7 días. Si revisas el material y sientes que no es para ti, puedes solicitar tu devolución dentro de ese periodo.',
  },
  {
    question: '¿Necesito experiencia previa en alimentación saludable?',
    answer:
      'No. La guía está diseñada para mamás ocupadas que necesitan pasos simples, prácticos y fáciles de aplicar en casa.',
  },
  {
    question: '¿Tengo que eliminar todos los alimentos procesados?',
    answer:
      'No. El enfoque no es extremo. La idea es ayudarte a reducir la improvisación, mejorar elecciones diarias y construir hábitos más conscientes poco a poco.',
  },
]
